import { lsGet, safeAwait } from 'utils/request'

export const getServiceClassificationById = (id) => {
  return safeAwait(lsGet(`/serviceClassifications/${id}`))
}
